import { apiRequest } from "./client";

export const listGuilds = () => apiRequest("/api/v1/guilds");

export const getGuild = (guildId) => apiRequest(`/api/v1/guilds/${guildId}`);

export const getGuildChannels = (guildId) => apiRequest(`/api/v1/guilds/${guildId}/channels`);

export const getGuildRoles = (guildId) => apiRequest(`/api/v1/guilds/${guildId}/roles`);

export const getGuildConfig = (guildId) => apiRequest(`/api/v1/guilds/${guildId}/config`);

export const updateGuildConfig = (guildId, payload) =>
  apiRequest(`/api/v1/guilds/${guildId}/config`, { method: "PATCH", body: payload });

export const getGuildActivity = (guildId, limit = 20) =>
  apiRequest(`/api/v1/guilds/${guildId}/activity?limit=${limit}`);

export const getChannelPermissions = (guildId, channelId) =>
  apiRequest(`/api/v1/guilds/${guildId}/channels/${channelId}/permissions`);

export const getAssignableRoles = (guildId) =>
  apiRequest(`/api/v1/guilds/${guildId}/roles/assignable`);
